export enum TwoFactorAuthentificationType {
  BankAccount = 'BankAccount',
  Transaction = 'Transaction',
  UserLoginTwoFactorAuth = 'UserLoginTwoFactorAuth',
  PhoneNumber = 'PhoneNumber',
  PhoneNumberChange = 'PhoneNumberChange',
}
